/**
 * PDP v2 — Sticky add-to-cart bar
 * Reveals when the main ATC button scrolls out of view.
 * Clicking the sticky CTA scrolls to / clicks the main ATC button.
 * Mirrors variant price changes via the variantChange PubSub event if present.
 */
(function () {
  function init() {
    const bar = document.querySelector('[data-pdp-sticky-atc]');
    if (!bar) return;
    const sectionId = bar.dataset.sectionId;
    const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
    if (!productInfo) return;

    const mainSubmit =
      productInfo.querySelector('product-form .product-form__submit') ||
      productInfo.querySelector('.gw-button-widget-container .gw-button-widget');
    if (!mainSubmit) return;

    const cta = bar.querySelector('[data-pdp-sticky-cta]');
    const ctaText = bar.querySelector('.pdp-sticky-atc__cta-text');
    const priceEl = bar.querySelector('[data-pdp-sticky-price]');

    // Show/hide based on main ATC visibility
    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries[0].isIntersecting;
        bar.toggleAttribute('hidden', visible);
        bar.classList.toggle('is-visible', !visible);
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0 }
    );
    io.observe(mainSubmit);

    // Click sticky CTA → click main submit (works for ATC + Notify Me)
    cta?.addEventListener('click', () => {
      const target =
        productInfo.querySelector('.gw-button-widget-container .gw-button-widget') ||
        productInfo.querySelector('product-form .product-form__submit');
      if (target) target.click();
    });

    // Sync CTA text + price on variant change
    function syncFromMain() {
      const target =
        productInfo.querySelector('.gw-button-widget-container .gw-button-widget') ||
        productInfo.querySelector('product-form .product-form__submit');
      if (!target) return;
      const text = target.textContent.trim();
      if (ctaText && text) ctaText.textContent = text;
      const priceItem = productInfo.querySelector('.price-item--last, .price-item--regular');
      if (priceEl && priceItem) priceEl.textContent = priceItem.textContent.trim();
    }
    syncFromMain();

    // Listen for variant changes via Dawn's PubSub
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => {
        setTimeout(syncFromMain, 50);
      });
    } else {
      const mo = new MutationObserver(syncFromMain);
      mo.observe(productInfo, { subtree: true, characterData: true, childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
